import trackingCodeController from './tracking-code.controller';
import trackingCodeView from './tracking-code.view.html';
import './tracking-code.scss';

const trackingCodeComponent = {
  template: trackingCodeView,
  controller: trackingCodeController,
  controllerAs: 'vm'
};

export default trackingCodeComponent;


// WEBPACK FOOTER //
// ./src/components/trackingcode/tracking-code.component.js